import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPlantInfo } from '../store';
import axios from 'axios';
import Nav from 'react-bootstrap/Nav';
import './Navbar.css';
import logo from '../image/logo_ci/logo_mrt.png';
import Button from 'react-bootstrap/Button';
import { LinkContainer } from 'react-router-bootstrap';
import {  Outlet,useLocation } from 'react-router-dom';

import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';

import config from '../config';
import { fetchIv_list, fetchEtc_list } from '../store';

import io from 'socket.io-client';
import { handleRealTimeDataIv, handleRealTimeDataEv, handleRealTimeDataJbMrt, handleRealTimeDataAcb, handleRealTimeDataDashboard, handleRealTimeDataRelay } from './websocketHandler';

import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import useIsMobile from '../hooks/useIsMobile';
import AutoCsvDownloadManager from '../routes/statistics/report/components/AutoCsvDownloadManager';

function Navbar({ onLogin }) {

  //모바일 페이지 감지
  const isMobile = useIsMobile();
  const [isExpanded, setIsExpanded] = useState(true);

  // ... existing code ...

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };



  const Etc_list = useSelector((state) => state.Etc_list || {});


  const dispatch = useDispatch();
  const plantInfo = useSelector((state) => state.plantInfo);
  const [show, setShow] = useState(false);
  const [alarms, setAlarms] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const lastAlarmTimeRef = useRef(0);
  const [macAddress, setMacAddress] = useState('');



  useEffect(() => {
    dispatch(fetchIv_list());
  }, [dispatch]);


  useEffect(() => {
    const socket = io(`${config.backendUrl}`, {
      transports: ['websocket']
    });

    socket.on('connect', () => {
      // console.log('Connected to WebSocket server from Navbar');
      socket.emit('request_time');
    });

    socket.on('real_time_data_inverter', (message) => {
      // console.log('real_time_data_inverter');
      handleRealTimeDataIv(message, dispatch);
    });

    socket.on('real_time_data_Sensor', (message) => {
      // console.log('real_time_data_Sensor');
      handleRealTimeDataEv(message, dispatch);
    });

    socket.on('real_time_data_JbMrt', (message) => {
      // console.log('real_time_data_JbMrt');
      handleRealTimeDataJbMrt(message, dispatch);
    });

    socket.on('real_time_data_ACB', (message) => {
      // console.log('real_time_data_ACB');
      handleRealTimeDataAcb(message, dispatch);
    });

    socket.on('real_time_data_relay', (message) => {
      handleRealTimeDataRelay(message, dispatch);
    });

    socket.on('real_time_data_dashboard', (message) => {
      // console.log('real_time_data_dashboard');
      handleRealTimeDataDashboard(message, dispatch); // ✅ getState 전달
    });

    socket.on('real_time_alarms', (messages) => {
      try {
        const parsedMessage = typeof messages === 'string'
          ? JSON.parse(messages)
          : (messages || {});

        if (Object.keys(parsedMessage).length > 0) {
          const newAlarms = Object.entries(parsedMessage).map(([alarmKey, message]) => {
            const separatorIdx = message.indexOf(' - ');
            const dateTime = separatorIdx !== -1 ? message.slice(0, separatorIdx) : '';
            const rest = separatorIdx !== -1 ? message.slice(separatorIdx + 3) : message;
            const colonIdx = rest.indexOf(': ');
            const cleanMessage = colonIdx !== -1 ? rest.slice(colonIdx + 2) : rest;

            let formattedDate = '';
            if (dateTime) {
              const date = new Date(dateTime);
              if (!Number.isNaN(date.getTime())) {
                formattedDate = `${date.getFullYear().toString().slice(2)}년${(date.getMonth() + 1).toString().padStart(2, '0')}월${date.getDate().toString().padStart(2, '0')}일 ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
              }
            }

            const displayMessage = formattedDate
              ? `${formattedDate} - ${cleanMessage}`
              : cleanMessage;

            return {
              id: `${alarmKey}-${dateTime || Date.now()}`,
              message: displayMessage,
            };
          });

          setAlarms((prevAlarms) => {
            const updatedAlarms = [...newAlarms, ...prevAlarms];
            const filteredAlarms = updatedAlarms
              .filter((alarm, index, self) => index === self.findIndex((t) => t.id === alarm.id))
              .sort((a, b) => {
                const timeA = a.id.split('-').slice(1).join('-');
                const timeB = b.id.split('-').slice(1).join('-');
                return new Date(timeB) - new Date(timeA);
              });
            const activeAlarmIds = new Set(newAlarms.map((alarm) => alarm.id));
            const finalAlarms = filteredAlarms.filter((alarm) => activeAlarmIds.has(alarm.id));

            if (finalAlarms.length > 0) {
              const currentTime = Date.now();
              if (currentTime - lastAlarmTimeRef.current > 30000) {
                setShowToast(true);
                lastAlarmTimeRef.current = currentTime;
              }
            } else {
              setShowToast(false);
            }
            return finalAlarms;
          });
        } else {
          setAlarms([]);
          setShowToast(false);
        }
      } catch (error) {
        console.error('메시지 파싱 중 오류 발생:', error);
      }
    });

    return () => {
      socket.off('real_time_data_inverter');
      socket.off('real_time_data_Sensor');
      socket.off('real_time_data_JbMrt');
      socket.off('real_time_data_ACB');
      socket.off('real_time_data_relay');
      socket.off('real_time_data_dashboard');
      socket.off('real_time_alarms');
      socket.off('connect');
      socket.close();
    };
  }, [dispatch]);

  const handleToastClose = () => {
    setShowToast(false);
    lastAlarmTimeRef.current = Date.now();
  };

  useEffect(() => {
    axios.get(`${config.backendUrl}/api/get-info`)
      .then(response => {
        dispatch(setPlantInfo(response.data));
      })
      .catch(error => {
        console.error('There was an error fetching the info!', error);
      });
  }, [dispatch]);

  useEffect(() => {
    axios.get(`${config.backendUrl}/api/system/mac-address`)
      .then(response => {
        if (response.data?.status === 'success' && response.data?.mac_address) {
          setMacAddress(response.data.mac_address);
        }
      })
      .catch(error => {
        console.error('There was an error fetching the MAC address!', error);
      });
  }, []);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const handleOpenManual = () => {
    const manualUrl = `${process.env.PUBLIC_URL}/Solar Monitoring System.pdf`;
    window.open(manualUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className='nav-header-container'>
      <div className='nav-title-container'>
        <div
          className="nav-logo"
          style={{
            marginTop: '-20px',
            marginBottom: '-20px',
            marginLeft: '-20px',
            paddingLeft: '20px',
            paddingRight: '20px',
            display: 'flex',
            alignItems: 'center',
            alignSelf: 'stretch',
          }}
        >
          <img
            src={`${config.backendUrl}/logo/${plantInfo.logo}`}
            alt="로고"
            style={{
              width: 'auto',
              height: '96px',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </div>
        <div className = 'nav-title' style={{ paddingLeft: '20px', paddingRight: '20px', fontSize: 'medium', fontWeight: '600' }}>
          <span style={{ color: 'yellow' }}>태양광 </span>
          <span style={{ color: 'white' }}>모니터링 시스템</span><br />
          <span style={{ color: '#AFBDDB' }}>SOLAR MONITORING SYSTEM</span>
        </div>
        <div className='nav-plantName' style={{ paddingLeft: '20px', paddingRight: '20px' }}>
          {plantInfo.name}
        </div>
      </div>
      <div>
        <NavbarMenu />
      </div>
      <div style={{ flexGrow: '1' }}></div>
      
      
      <div className='nav-buttonAndVer-container'>
        <div className='nav-buttonbox'>
          {!isMobile && (
            <>
              <Button className='nav-button' variant="outline-light" onClick={handleOpenManual}>설명서</Button>
              <Button className='nav-button' variant="primary" onClick={handleShow}>관리자</Button>
            </>
          )}
          {/* <Button className='nav-button' variant="danger">로그아웃</Button> */}
        </div> 
        
        <div className="nav-version-text">Ver. B: bb016 / F: fb016</div>
        <div className="nav-contact-row">
          <div className="nav-contact-item">MAC: {macAddress || '-'}</div>
          <div className="nav-contact-item nav-contact-item-phone">☎ A/S {plantInfo.callnumber}</div>
        </div>
      </div>
      
      
      <AdminLoginModal show={show} handleClose={handleClose} onLogin={onLogin} />

      <ToastContainer position="top-end" className="p-3 custom-toast-container" style={{ zIndex: 1 }}>
        <Toast
          onClose={handleToastClose}
          show={showToast && alarms.length > 0}
          className="custom-toast"
          style={{ width: '500px' }}
        >
          <Toast.Header className="custom-toast-header" style={{ backgroundColor: '#ff6b6b' }}>
            <strong className="me-auto">새로운 알람 ({alarms.length})</strong>
            <Button
              variant="link"
              onClick={toggleExpand}
              style={{ color: 'white', textDecoration: 'none', padding: '0 10px' }}
            >
              {isExpanded ? '접기' : '펼치기'}
            </Button>
          </Toast.Header>
          <Toast.Body
            className="custom-toast-body"
            style={{
              backgroundColor: '#ffffff',
              maxHeight: isExpanded ? '300px' : '0',
              overflowY: 'auto',
              transition: 'max-height 0.3s ease-in-out, padding 0.3s ease-in-out',
              padding: isExpanded ? '0.75rem' : '0',
              margin: 0,
              border: 'none'
            }}
          >
            {alarms.slice().reverse().map((alarm) => (
              <div key={alarm.id} className="alarm-item">{alarm.message}</div>
            ))}
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <AutoCsvDownloadManager />
      <Outlet />
    </div>
  );
}


function NavbarMenu() {


  const dispatch = useDispatch();
  const Etc_list = useSelector((state) => state.Etc_list || {});


  const hasJKVibration = Etc_list.Etc_protocol && Etc_list.Etc_protocol.includes('JK진동V1');
  const location = useLocation();
  const [activeKey, setActiveKey] = useState('');

  useEffect(() => {
    dispatch(fetchEtc_list());
  }, [dispatch]);

  useEffect(() => {
    switch (location.pathname) {
      case '/':
      case '/pvstatus':
        setActiveKey('home');
        break;
      case '/measurement':
        setActiveKey('link-1');
        break;
      case '/statistics':
        setActiveKey('link-2');
        break;
      case '/alarm':
        setActiveKey('link-3');
        break;
      case '/vibrationDetection':
        setActiveKey('link-4');
        break;
      case '/schedule':
        setActiveKey('link-5');
        break;
      case '/diagram':
        setActiveKey('link-6');
        break;
      default:
        setActiveKey('home');
    }
  }, [location.pathname]);

  const handleSelect = (eventKey) => {
    setActiveKey(eventKey);
  }

  return (
    <div>
      <Nav justify variant="tabs" activeKey={activeKey} onSelect={handleSelect}>
        
        <Nav.Item>
          <LinkContainer to="/pvstatus">
            <Nav.Link eventKey="home" className='nav-link-container'>
              <div className="nav-image-container">
                {activeKey === 'home' ? (
                  <div className="nav-image-crop" style={{ top: '0px', left: '-27px' }}></div>
                ) : (
                  <div className="nav-image-crop" style={{ top: '0px', left: '0px' }}></div>
                )}
              </div>
              <div>발전현황</div>
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>
        
        <Nav.Item>
          <LinkContainer to="/measurement">
            <Nav.Link eventKey="link-1" className='nav-link-container'>
              <div className="nav-image-container">
                {activeKey === 'link-1' ? (
                  <div className="nav-image-crop" style={{ top: '-27px', left: '-27px' }}></div>
                ) : (
                  <div className="nav-image-crop" style={{ top: '-27px', left: '0px' }}></div>
                )}
              </div>
              <div>계측장비</div>
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>
        
        {/* <Nav.Item>
          <LinkContainer to="/schedule">
            <Nav.Link eventKey="link-5" className='nav-link-container'>
              <div className="nav-image-container">
                {activeKey === 'link-5' ? (
                  <div className="nav-image-crop" style={{ top: '-215px', left: '-27px' }}></div>
                ) : (
                  <div className="nav-image-crop" style={{ top: '-215px', left: '0px' }}></div>
                )}
              </div>
              <div>출력제어</div>
            </Nav.Link>
          </LinkContainer>
        </Nav.Item> */}
{/* 
        <Nav.Item>
          <LinkContainer to="/diagram">
            <Nav.Link eventKey="link-6" className='nav-link-container'>
              <div className="nav-image-container">
                {activeKey === 'link-6' ? (
                  <div className="nav-image-crop" style={{ top: '-54px', left: '-27px' }}></div>
                ) : (
                  <div className="nav-image-crop" style={{ top: '-54px', left: '0px' }}></div>
                )}
              </div>
              <div>계통도</div>
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>  */}

        {/* 진동 감지 메뉴 - `JK진동V1`이 있을 때만 표시 */}
        {hasJKVibration && (
          <Nav.Item>
            <LinkContainer to="/vibrationDetection">
              <Nav.Link eventKey="link-4" className="nav-link-container">
                <div className="nav-image-container">
                  {activeKey === 'link-4' ? (
                    <div className="nav-image-crop" style={{ top: '-188px', left: '-27px' }}></div>
                  ) : (
                    <div className="nav-image-crop" style={{ top: '-188px', left: '0px' }}></div>
                  )}
                </div>
                <div>진동감지</div>
              </Nav.Link>
            </LinkContainer>
          </Nav.Item>
        )}

        <Nav.Item>
          <LinkContainer to="/statistics">
            <Nav.Link eventKey="link-2" className='nav-link-container'>
              <div className="nav-image-container">
                {activeKey === 'link-2' ? (
                  <div className="nav-image-crop" style={{ top: '-107px', left: '-27px' }}></div>
                ) : (
                  <div className="nav-image-crop" style={{ top: '-107px', left: '0px' }}></div>
                )}
              </div>
              <div>통계</div>
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>
        <Nav.Item>
          <LinkContainer to="/alarm">
            <Nav.Link eventKey="link-3" className='nav-link-container'>
              <div className="nav-image-container">
                {activeKey === 'link-3' ? (
                  <div className="nav-image-crop" style={{ top: '-134px', left: '-27px' }}></div>
                ) : (
                  <div className="nav-image-crop" style={{ top: '-134px', left: '0px' }}></div>
                )}
              </div>
              <div>경보</div>
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>
      </Nav>
    </div>
  );
}

function AdminLoginModal({ show, handleClose, onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (show) {
      setPassword('');
      setError('');
    }
  }, [show]);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setError('');
  };

  const handleAdminLogin = (e) => {
    e.preventDefault();
    axios.post(`${config.backendUrl}/api/verify-password`, { password })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          // console.log('Password verification successful');
          navigate('/admin');
        } else {
          setError('비밀번호가 틀렸습니다.');
        }
      })
      .catch(error => {
        console.error('There was an error verifying the password!', error);
        setError('서버 오류가 발생했습니다.');
      });
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>비밀번호 입력</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleAdminLogin}>
          <Form.Group controlId="formPassword">
            <Form.Label>비밀번호</Form.Label>
            <Form.Control
              type="password"
              placeholder="비밀번호를 입력하세요"
              value={password}
              onChange={handlePasswordChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>닫기</Button>
        <Button variant="primary" onClick={handleAdminLogin}>로그인</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default Navbar;
